export default "__VITE_ASSET__BMci8$_o__"